<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Monitorings"
};
</script>

<style scoped>
</style>
